import React, { useMemo } from 'react';
import {
    Avatar,
    Grid,
    IconButton,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Delete } from '@material-ui/icons';
import PriceSelector from '%paysera_seat_selection_integration/js/seatings/Page/components/Cart/component/PriceSelector';
import CountSelector from '%paysera_seat_selection_integration/js/seatings/Page/components/Cart/component/CountSelector';
import cartItemShape from '%paysera_seat_selection_integration/js/seatings/propTypes/cartItemShape';
import ticketTypeShape from '%paysera_seat_selection_integration/js/seatings/propTypes/ticketTypeShape';
import { OBJECT_TYPE_GENERAL_ADMISSION } from '%paysera_seat_selection/js/seatSelection/config/constants';
import buildSeatingLabels from './buildSeatingLabels';

function SeatingCartItem({
    classes: { icon, item },
    item: {
        price_type: { hash },
        tickets_count: ticketsCount,
        order_detail_id: orderDetailId,
        seating: { type },
    },
    ticketType: {
        hash: ticketTypeHash,
        min_tickets_count: minTicketsCount,
        max_tickets_count: maxTicketsCount,
    },
    currency,
    selectPriceType,
    selectTicketTypeCount,
    removeCartItem,
    seatingModel,
}) {
    const [primaryText, secondaryText] = useMemo(() => buildSeatingLabels(seatingModel), [seatingModel]);

    return (
        <ListItem className={item}>
            <ListItemAvatar>
                <Avatar className={icon}>
                    {' '}
                </Avatar>
            </ListItemAvatar>
            <ListItemText disableTypography>
                <Grid alignItems="center" container>
                    <Grid xs={12} md={6} item>
                        <Typography>{primaryText}</Typography>
                        <Typography color="textSecondary" variant="body2">{secondaryText}</Typography>
                    </Grid>
                    <Grid xs={12} md={6} item>
                        <Grid alignItems="flex-start" container>
                            <Grid xs={12} md={10} item>
                                <PriceSelector
                                    currency={currency}
                                    ticketTypeHash={ticketTypeHash}
                                    currentHash={hash}
                                    selectPriceType={priceTypeHash => selectPriceType({
                                        id: orderDetailId,
                                        hash: priceTypeHash,
                                    })}
                                />
                            </Grid>
                            <Grid xs={12} md={2} item>
                                {type === OBJECT_TYPE_GENERAL_ADMISSION && (
                                    <CountSelector
                                        min={1}
                                        max={maxTicketsCount}
                                        currentCount={ticketsCount}
                                        selectCount={count => selectTicketTypeCount({
                                            id: orderDetailId,
                                            count,
                                        })}
                                    />
                                )}
                                {type !== OBJECT_TYPE_GENERAL_ADMISSION && (
                                    <CountSelector currentCount={ticketsCount} />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItemText>
            <ListItemSecondaryAction>
                <IconButton onClick={() => removeCartItem({ id: orderDetailId })} edge="end">
                    <Delete fontSize="small" />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
}

SeatingCartItem.propTypes = {
    classes: PropTypes.shape({
        icon: PropTypes.string.isRequired,
        item: PropTypes.string.isRequired,
    }).isRequired,
    item: PropTypes.shape(cartItemShape).isRequired,
    ticketType: PropTypes.shape(ticketTypeShape).isRequired,
    currency: PropTypes.string.isRequired,
    selectTicketTypeCount: PropTypes.func.isRequired,
    selectPriceType: PropTypes.func.isRequired,
    removeCartItem: PropTypes.func.isRequired,
    seatingModel: PropTypes.object,
};

SeatingCartItem.defaultProps = {
    seatingModel: {},
};

export default React.memo(SeatingCartItem);
